import { render, staticRenderFns } from "./PIadmin.vue?vue&type=template&id=51377502&scoped=true"
import script from "./PIadmin.vue?vue&type=script&lang=js"
export * from "./PIadmin.vue?vue&type=script&lang=js"
import style0 from "./PIadmin.vue?vue&type=style&index=0&id=51377502&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51377502",
  null
  
)

export default component.exports